module.exports = __webpack_public_path__ + "static/media/Arrow-Right-Highlighted.3149a50c.svg";